import LayoutDefault from '@/components/layouts/layout-default/index.vue'
import { RouteRecordRaw } from 'vue-router'
import { translate } from '@/languages/i18n'
import { store } from '@/store'
import { COMMUNITY_STORE } from '@/store/constants'

const checkAndHandleCommunityAccessUserList = async (communityId, next) => {
  await store.dispatch(COMMUNITY_STORE.ACTIONS.SET_COMMUNITY_INFO, communityId)

  if (!store.state.community.member_display_setting) {
    next({
      replace: true,
      path: '/404',
    })
    return false
  }
  return true
}

export default (): RouteRecordRaw[] => {
  return [
    {
      path: '/alumni/communities/:id',
      name: 'alumni home',
      component: () => import('@/views/user/community/home/index.vue'),
      meta: {
        title: translate('titleHeadUser'),
        screenId: 'SF10',
        layout: LayoutDefault,
      },
    },

    {
      path: '/alumni/lobby',
      name: 'lobby',
      component: () => import('./lobby/index.vue'),
      meta: {
        title: translate('titleHeadUser'),
        screenId: 'SD10',
        layout: LayoutDefault,
        hideSidebar: true,
      },
    },
    {
      path: '/alumni/communities/:id/users',
      name: 'alumni users',
      component: () => import('@/views/user/community/users/index.vue'),
      meta: {
        title: translate('titleHeadUser'),
        screenId: 'SQ10',
        layout: LayoutDefault,
      },
      beforeEnter: async (to, _from, next) => {
        const hasPermission = await checkAndHandleCommunityAccessUserList(to.params.id, next)
        if (hasPermission) {
          next()
        }
      },
    },
    {
      path: '/community/communities/:id/users',
      name: 'community users',
      component: () => import('@/views/user/community/users/index.vue'),
      meta: {
        title: translate('titleHeadUser'),
        screenId: 'SQ10',
        layout: LayoutDefault,
      },
      beforeEnter: async (to, _from, next) => {
        const hasPermission = await checkAndHandleCommunityAccessUserList(to.params.id, next)
        if (hasPermission) {
          next()
        }
      },
    },
  ]
}
